import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbFileListInnerBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`file-list-inner ${props.attributes.className ? props.attributes.className : ''} ${classes.fileListInner}`}>
        <div className="image-col">
            {blocks[0]}
        </div>
        <div className="con-col">
            {blocks[1]}
            {blocks[2]}
            {blocks[3]}
        </div>
    </div>
};

export const CgbFileListInnerBlockFragment = graphql`
  fragment CgbFileListInnerBlock on WpBlock {
    ... on WpCgbFileListInnerBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFileListInnerBlockPreview = `
    ... on CgbFileListInnerBlock {
        name
        attributes {
            className
        }
    }
`;